import React from 'react';

import { BaseIconProps } from '.';
export const ErrorSign = ({ fill }: BaseIconProps) => (
  <g>
    <path
      fill={fill}
      strokeWidth="0.99999994"
      d="m 487.80559,695.88164 v 103.9211 h 104.4408 v -103.9211 z m 0,-415.68438 v 311.76329 h 104.4408 V 280.19726 Z M 330.00146,176.27616 H 750.10249 L 960.12699,540 749.99859,903.72384 H 330.00146 L 119.873,540 Z M 269.93506,72.35507 1e-5,540 269.93506,1007.6449 H 810.06499 L 1080,540 810.06499,72.35507 Z"
    />
  </g>
);
